import MainLayout from "../components/layout/MainLayout";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import EventSubmission from "../pages/events/EventSubmission";
import Events from "../pages/events/Events";
import OrganizationSearch from "../pages/organizations/OrganizationSearch";
import OrganizationTruncatedRankings from "../pages/rankings/OrganizationTruncatedRankings";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import NotFound from "../pages/utility/NotFound";
import { getEnvironmentVariable } from "../global/environmentVariables";
import OrganizationDashboard from "../pages/organizations/components/OrganizationDashboard";
import Leaderboards from "../pages/leaderboards/Leaderboards";
import { Navigate } from "react-router";

export const organizationRoutes = (
  authContext,
  itemsMiddle,
  setItemsMiddle,
  eventObject,
  setEventObject
) => {
  const forceLoginParam = findGetParameter("forceLogin");
  const LEADERBOARDS =
    getEnvironmentVariable("LEADERBOARDS") === "true" ||
    getEnvironmentVariable("COMPANY_FLAG") === "gw" ||
    (getEnvironmentVariable("IS_DEV") === "true" &&
      localStorage?.getItem("leaderboardRedesign") === "true");

  return [
    {
      path: "distributor",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "organizations",
          element: <OrganizationSearch distributorView />,
        },
        {
          path: "store-finder",
          element: (
            <OrganizationSearch organizationType="store" distributorView />
          ),
        },
        {
          path: "club-finder",
          element: (
            <OrganizationSearch organizationType="club" distributorView />
          ),
        },

        { path: "*", element: <NotFound /> },
      ],
    },
    {
      path: "organization",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            event={eventObject}
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "rankings/:organizationId",
          element: getEnvironmentVariable("HIDE_RANKINGS") ? (
            <NotFound />
          ) : (
            <OrganizationTruncatedRankings />
          ),
        },
        {
          path: "leaderboards/:organizationId",
          element: getEnvironmentVariable("HIDE_RANKINGS") ? (
            <NotFound />
          ) : !LEADERBOARDS &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.adminGameSystems?.length ? (
            <Navigate to="/access-denied" />
          ) : (
            <Leaderboards activeTab="overview" organization />
          ),
        },
        {
          path: "leaderboards/:organizationId/:leagueId",
          element: getEnvironmentVariable("HIDE_RANKINGS") ? (
            <NotFound />
          ) : !LEADERBOARDS &&
            authContext?.authState?.identity?.isAdmin !== true &&
            !authContext?.authState?.identity?.adminGameSystems?.length ? (
            <Navigate to="/access-denied" />
          ) : (
            <Leaderboards activeTab="truncated" organization />
          ),
        },
        {
          path: ":organizationId",
          element: <OrganizationDashboard />,
        },
        {
          path: "eventsubmission/:organizationId",
          element: <EventSubmission />,
        },
        {
          path: "event-submission/:organizationId",
          element: <EventSubmission />,
        },
        {
          path: "token-request/:organizationId",
          element: <EventSubmission />,
        },
        {
          path: "tokenrequest/:organizationId",
          element: <EventSubmission />,
        },
        {
          path: "events/:organizationId",
          element: <Events />,
        },
      ],
    },
  ];
};
